import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import {
  PORTAL_URL,
  subscribeToConfigChanges
} from '~/common/helpers/environment';
import parseStringWithVariable from '~/common/helpers/parseStringWithVariable';
import withHooks from '~/common/hoc/withHooks';
import { StoreRootState } from '~/scenes/Governance/types/StoreRootState';

let currentPortalUrl = PORTAL_URL;

// Subscribe to config changes to get updated PORTAL_URL
subscribeToConfigChanges((config: any) => {
  if (config.PORTAL_URL) {
    currentPortalUrl = config.PORTAL_URL;
  }
});

export type Props = {
  redirectToRealm: (realm: string) => void;
};

const enhancer = withHooks((outProps: object) => {
  const { application } = useSelector((state: StoreRootState) => state);

  useEffect(() => {
    if (application?.subdomain)
      window.location.href = parseStringWithVariable(currentPortalUrl, {
        realm: application?.subdomain
      });
  }, []);

  const props: Props = {
    redirectToRealm: realm => {
      window.location.href = parseStringWithVariable(currentPortalUrl, {
        realm
      });
    }
  };

  return {
    ...outProps,
    ...props
  };
});

export default enhancer;
